import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import requiredIf from '../../../../functions/requiredIf';
import './StyleControls.css';

const StyleControls = (props) => {
  const selection = props.editorState.getSelection();
  const blockType = props.editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();
  let currentStyle = props.editorState.getCurrentInlineStyle();
  
  let styleControlsClasses = classNames('rich-text-editor__style-controls', {
    'rtl': (props.textDirection === "RTL")
  });

  let inlineOptions = (props.inlineOptions) ? 
    props.inlineOptions.map((option) =>
      <StyleButton
        key={option.label}
        isActive={currentStyle.has(option.style)}
        label={option.label}
        onToggle={props.onInlineToggle}
        style={option.style}
      />
    ) : 
    null;

  let blockOptions = (props.blockOptions) ? 
    props.blockOptions.map((option) =>
      <StyleButton
        key={option.label}
        isActive={option.style === blockType}
        label={option.label}
        onToggle={props.onBlockToggle}
        style={option.style}
      />
    ) : 
    null;
  
  let toggleOptions = (props.toggleOptions) ? 
    props.toggleOptions.map((option) =>
      <StyleButton
        key={option.label}
        isActive={currentStyle.has(option.style)}
        label={option.label}
        activeLabel={option.activeLabel}
        onToggle={option.onInactiveToggle}
        onActiveToggle={option.onActiveToggle}
        style={option.style}
      />
    ) : 
    null;

  return (
    <div className={styleControlsClasses}>
      {inlineOptions}
      {blockOptions}
      {toggleOptions}
    </div>
  );
}

StyleControls.defaultProps = {
  textDirection: 'LTR'
}

StyleControls.propTypes = {
  blockOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    style: PropTypes.string.isRequired
  })),
  editorState: PropTypes.object.isRequired, 
  inlineOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    style: PropTypes.string.isRequired
  })),
  onBlockToggle: requiredIf(PropTypes.func, props => props.blockOptions),
  onInlineToggle: requiredIf(PropTypes.func, props => props.inlineOptions),
  textDirection: PropTypes.oneOf(['RTL', 'LTR']),
  toggleOptions: PropTypes.arrayOf(PropTypes.shape({
    activeLabel: PropTypes.string,
    label: PropTypes.string,
    onActiveToggle: PropTypes.func,
    onInactiveToggle: PropTypes.func.isRequired,
    style: PropTypes.string
  }))
}

class StyleButton extends Component {
  constructor() {
    super();
    this.onToggle = (e) => {
      e.preventDefault();
      
      let toggleFunc = (this.props.onActiveToggle && this.props.isActive) ?
        this.props.onActiveToggle :
        this.props.onToggle;
      
      toggleFunc(this.props.style);
    };
  }
  
  render() {
    let className = 'rich-text-editor__button';
    let label = this.props.label;
  
    if (this.props.isActive) {
      className += ' rich-text-editor__button--active';
      label = (this.props.activeLabel) ?
        this.props.activeLabel :
        this.props.label;
    }
  
    return (
      <span className={className} onClick={this.onToggle}>
        {label}
      </span>
    );
  }
}

StyleButton.propTypes = {
  activeLabel: PropTypes.string,
  isActive: PropTypes.bool,
  label: PropTypes.string,
  onActiveToggle: PropTypes.func,
  onToggle: PropTypes.func.isRequired,
  style: PropTypes.string
}

export { StyleControls, StyleButton };


// WEBPACK FOOTER //
// ./src/shared/components/presentation/rich-text-editor/style-controls/StyleControls.js